import {
  IconCirclePercentage,
  IconNotesOff,
  IconTrendingDown,
  IconClockBolt,
  IconSteeringWheelFilled,
  IconLockOpen2,
} from '@tabler/icons-react';
import { Container, SimpleGrid, Text, ThemeIcon, Title, Badge} from '@mantine/core';
import classes from './Advantages.module.css';

export const MOCKDATA = [
  {
    icon: IconCirclePercentage,
    title: 'Obtén hasta el 80% del valor de tu vehículo',
    description:
      'Te ofrecemos hasta el 80% del valor de tu vehículo o un mínimo de $50,000 pesos, asegurando que obtengas la mejor oferta posible.',
  },
  {
    icon: IconTrendingDown,
    title: 'Accede a la mejor tasa del mercado',
    description: (
      <>
        Disfruta de una <Badge color="blue" size="md">tasa del 3%</Badge> y condiciones flexibles para tu préstamo.
      </>
    ),
  },
  {
    icon: IconClockBolt,
    title: 'Rapidez y simplicidad',
    description:
      'El proceso es rápido y sencillo. Puedes recibir el dinero en cuestión de horas o 1 día.',
  },
  {
    icon: IconSteeringWheelFilled,
    title: 'Sigue manejando tu vehículo',
    description:
      'Puedes seguir utilizando tu auto mientras pagas tu préstamo. No necesitas dejarlo con nosotros.',
  },
  {
    icon: IconNotesOff,
    title: 'No necesitas comprobar ingresos',
    description:
      'No es necesario presentar recibos de sueldo o comprobantes de ingresos para acceder a tu préstamo.',
  },
  {
    icon: IconLockOpen2,
    title: 'Accecibilidad para todos',
    description:
      'Condiciones más flexibles que los bancos tradicionales, lo que permite obtener el préstamo sin necesidad de un historial crediticio perfecto.',
  },
];

interface FeatureProps {
  icon: React.FC<any>;
  title: React.ReactNode;
  description: React.ReactNode;
}

export function Feature({ icon: Icon, title, description }: FeatureProps) {
  return (
    <div>
      <ThemeIcon variant="light" size={45} radius={40}>
        <Icon size={30} stroke={1.5} />
      </ThemeIcon>
      <Text mt="sm" mb={7}>
        {title}
      </Text>
      <Text size="sm" c="dimmed" lh={1.6} className={classes.decriptionCard}>
        {description}
      </Text>
    </div>
  );
}

export function AdvantagesGrid() {
  const features = MOCKDATA.map((feature, index) => <Feature {...feature} key={index} />);

  return (
    <Container component={'section'} className={classes.wrapper} id="ventajas">
      <Title className={classes.title}>Ventajas de empeñar tu vehículo con nosotros</Title>

      <Container size={560} p={0}>
        <Text size="md" className={classes.description}>
          Te ofrecemos una solución rápida, segura y sin complicaciones. Con nosotros, obtienes el
          dinero que necesitas sin dejar de usar tu vehículo.
        </Text>
      </Container>

      <SimpleGrid
        mt={60}
        cols={{ base: 1, sm: 2, md: 3 }}
        spacing={{ base: 'xl', md: 50 }}
        verticalSpacing={{ base: 'xl', md: 50 }}
      >
        {features}
      </SimpleGrid>
    </Container>
  );
}
